import React, { Component } from "react";
import { Div, Image, Text, Icon } from "atomize";
import { Link } from "gatsby";

class HowThumbnail extends Component {
  // state = {
  //   turnCard: false,
  // }

  render() {
    // const { turnCard } = this.state
    const { content, index, currentSlide, ...rest } = this.props;
    let thumbnailClass;

    if (index === currentSlide) {
      thumbnailClass = "thumb-slide-active";
    } else if (index > currentSlide) {
      thumbnailClass = "thumb-slide-inactive";
    } else if (index < currentSlide) {
      thumbnailClass = "thumb-slide-visited";
    }

    return (
      <Div
        {...rest}
        cursor="pointer"
        className={`thumb-slide ${thumbnailClass}`}
      >
        <Div
          p={{ xs: "0.875rem", sm: "1.25rem 1.25rem 1.05rem 1.25rem" }}
          rounded="xs"
        >
          <Div
            d="flex"
            align="center"
            pos="absolute"
            left="0"
            top="-1.1rem"
            w="calc(100% + 1.2rem)"
            m={{ l: "calc(-50% - 0.6rem)" }}
          >
            <Div
              className="before-line"
              flexGrow="1"
              bg="#626262"
              h="1px"
              opacity="0.7"
              transition
            />
            <Div
              className="thumb-bullet"
              rounded="circle"
              bg="black550"
              w="8px"
              h="8px"
              zIndex="10"
            />
            <Div
              className="after-line"
              pos="absolute"
              left="0"
              top="50%"
              transform="translateY(-50%) scaleX(0)"
              transformOrigin="left"
              zIndex="1"
              bg="gray700"
              h="3px"
              w="100%"
              transition="transform 0.5s linear"
            />
          </Div>
          <Text
            textSize={{ xs: "caption2", sm: "body" }}
            textColor="gray700"
            textWeight="700"
            p="0 0 0.2rem 0"
            tag="h2"
          >
            {content.title}
          </Text>
          <Text
            textSize={{ xs: "caption", sm: "caption2" }}
            style={{ lineHeight: "1.1rem" }}
            textColor="gray700"
          >
            {content.description}
          </Text>
        </Div>
      </Div>
    );
  }
}

export default HowThumbnail;
